import applicationModal from "./applicationModal.cjs";
import request from "@/tool/request";
import API from "@/tool/api";
import {
    getResultData,
    getResultMessage,
    isResultSuccess,
} from "@/tool/result";

// Each mounted professional form owns its agreement, drafts and asynchronous epoch.
export default (professionalType) => ({
    mixins: [applicationModal],
    data() {
        return {
            applicationEpoch: 0,
            agreementTimer: null,
            agreementEpoch: 0,
            agreement: {
                accepted: false,
                version: "",
                content: "",
                ready: false,
                loading: false,
                error: "",
                reader: false,
                reminder: false,
                remaining: 10,
            },
        };
    },
    computed: {
        applicationIdentity() {
            const user = this.$store.state.user;
            return `${user.sessionVersion}:${user.user_id}:${user.is_login}`;
        },
        agreementTitle() {
            return professionalType === 1
                ? "吉享空间摄影服务承揽协议"
                : "吉享空间化妆服务承揽协议";
        },
    },
    watch: {
        applicationIdentity() {
            this.invalidateApplication();
            if (this.visible && this.$store.state.user.is_login)
                this.openDialog();
            else this.$emit("close");
        },
        visible(value) {
            if (!value) this.invalidateApplication();
        },
    },
    beforeDestroy() {
        this.invalidateApplication();
    },
    methods: {
        applicationContext() {
            return {
                epoch: this.applicationEpoch,
                identity: this.applicationIdentity,
            };
        },
        applicationIsCurrent(context) {
            return (
                !this._isDestroyed &&
                this.visible &&
                context.epoch === this.applicationEpoch &&
                context.identity === this.applicationIdentity
            );
        },
        stopAgreementTimer() {
            if (this.agreementTimer !== null)
                window.clearInterval(this.agreementTimer);
            this.agreementTimer = null;
        },
        resetAgreement() {
            this.agreementEpoch += 1;
            this.stopAgreementTimer();
            Object.assign(this.agreement, {
                accepted: false,
                version: "",
                content: "",
                ready: false,
                loading: false,
                error: "",
                reader: false,
                reminder: false,
                remaining: 10,
            });
        },
        invalidateApplication() {
            this.applicationEpoch += 1;
            this.resetAgreement();
            this.stopSmsTimer();
            if (this.revokeAllSamplePreviews) this.revokeAllSamplePreviews();
            if (this.revokeOriginalWorkPreviews)
                this.revokeOriginalWorkPreviews();
            this.form = this.createEmptyForm();
            this.smsSending = false;
            this.submitting = false;
            this.openSelectId = null;
        },
        readAgreement() {
            if (this.submitting || this.agreement.loading) return;
            this.resetAgreement();
            this.agreement.reader = true;
            this.agreement.loading = true;
            const context = this.applicationContext();
            const readerEpoch = this.agreementEpoch;
            const current = () =>
                this.applicationIsCurrent(context) &&
                readerEpoch === this.agreementEpoch &&
                this.agreement.reader;
            return request
                .get(API.creatorCenter.applicationAgreement(professionalType))
                .then((response) => {
                    if (!current()) return;
                    if (!isResultSuccess(response)) throw response;
                    const body = getResultData(response) || {};
                    if (
                        body.configured !== true ||
                        Number(body.professionalType) !== professionalType ||
                        typeof body.content !== "string" ||
                        !body.content.trim() ||
                        typeof body.version !== "string" ||
                        !body.version.trim()
                    ) {
                        this.agreement.error =
                            body.unavailableReason ||
                            "本专业正式协议暂未配置，暂时无法提交申请";
                        return;
                    }
                    this.agreement.content = body.content;
                    this.agreement.version = body.version;
                    this.agreement.ready = true;
                    // The configured plain-text body is now available. No timer runs before this point.
                    this.agreement.remaining = 10;
                    this.agreementTimer = window.setInterval(() => {
                        if (!current()) {
                            this.stopAgreementTimer();
                            return;
                        }
                        this.agreement.remaining = Math.max(
                            0,
                            this.agreement.remaining - 1
                        );
                        if (this.agreement.remaining === 0)
                            this.stopAgreementTimer();
                    }, 1000);
                })
                .catch((error) => {
                    if (!current()) return;
                    this.agreement.error = getResultMessage(
                        error,
                        "协议加载失败，请重试"
                    );
                })
                .finally(() => {
                    if (current()) this.agreement.loading = false;
                });
        },
        toggleAgreement() {
            if (this.submitting) return;
            if (this.agreement.accepted) this.agreement.accepted = false;
            else this.readAgreement();
        },
        acceptAgreement() {
            if (
                !this.agreement.reader ||
                !this.agreement.ready ||
                this.agreement.loading ||
                this.agreement.error ||
                this.agreement.remaining > 0
            )
                return;
            this.agreement.accepted = true;
            this.agreement.reader = false;
            this.returnToAgreement();
        },
        exitAgreement() {
            this.resetAgreement();
            this.returnToAgreement();
        },
        returnToAgreement() {
            this.agreement.reminder = false;
            this.$nextTick(() => {
                if (this.$refs.agreementPanel)
                    this.$refs.agreementPanel.focusCheckbox();
            });
        },
        checkApplicationAgreement() {
            if (
                !this.agreement.accepted ||
                !this.agreement.ready ||
                !this.agreement.version
            ) {
                this.agreement.reminder = true;
                return false;
            }
            return true;
        },
        appendApplicationAgreement(formData) {
            formData.append("agreementAccepted", "true");
            formData.append(
                "agreementProfessionalType",
                String(professionalType)
            );
            formData.append("agreementVersion", this.agreement.version);
        },
        recoverAgreementConflict(error) {
            const payload = this.errorPayload(error) || {};
            if (
                Number(
                    payload.code ||
                        (error && error.response && error.response.status)
                ) !== 409
            )
                return;
            this.submitting = false;
            this.readAgreement();
            this.formError =
                "协议或申请状态已变化，请阅读当前协议并重新确认后再提交";
        },
    },
});
